import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { HelmetProvider } from "react-helmet-async";
import { Navbar } from "@/components/layout/Navbar";
import { Footer } from "@/components/layout/Footer";
import { CartProvider } from "@/lib/cart";
import { CartDrawer } from "@/components/common/CartDrawer";
import { PageSettingsProvider } from "@/lib/page-settings";
import { PageGuard } from "@/components/common/PageGuard";
import { PURCHASING_ENABLED } from "@/lib/purchasing";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Artists from "@/pages/Artists";
import ArtistDetail from "@/pages/ArtistDetail";
import ArtworkDetail from "@/pages/ArtworkDetail";
import Events from "@/pages/Events";
import EventDetail from "@/pages/EventDetail";
import Contact from "@/pages/Contact";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import "@/App.css";

function AppRoutes() {
  const location = useLocation();
  const isAdmin = location.pathname.startsWith("/admin");

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [location.pathname]);

  return (
    <>
      {!isAdmin && <Navbar />}
      <Routes>
        {/* Home is always accessible (safety guarantee per spec). */}
        <Route path="/" element={<Home />} />
        {/* All other public routes are gated by admin-controlled visibility. */}
        <Route path="/about" element={<PageGuard><About /></PageGuard>} />
        <Route path="/artists" element={<PageGuard><Artists /></PageGuard>} />
        <Route path="/artists/:slug" element={<PageGuard><ArtistDetail /></PageGuard>} />
        <Route path="/artists/:slug/:pieceSlug" element={<PageGuard><ArtistDetail /></PageGuard>} />
        <Route path="/artwork/:id" element={<PageGuard><ArtworkDetail /></PageGuard>} />
        <Route path="/events" element={<PageGuard><Events /></PageGuard>} />
        <Route path="/events/:id" element={<PageGuard><EventDetail /></PageGuard>} />
        <Route path="/contact" element={<PageGuard><Contact /></PageGuard>} />
        {/* Admin routes are internal and never gated. */}
        <Route path="/admin" element={<AdminLogin />} />
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
      </Routes>
      {!isAdmin && <Footer />}
      {!isAdmin && PURCHASING_ENABLED && <CartDrawer />}
    </>
  );
}

function App() {
  return (
    <HelmetProvider>
    <BrowserRouter>
      <PageSettingsProvider>
        <CartProvider>
          <AppRoutes />
        </CartProvider>
      </PageSettingsProvider>
    </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
